<footer>
  <div></div>
  <img src="assets/images/B-saffron.svg" alt="Bulgari logo">
  <!-- <a class="btn btn-link" href="assets/pdf/termsofuse.pdf" download="termsofuse.pdf">
    {{"TERMS OF USE"|translate}}
  </a> -->
  <a class="btn btn-link" [routerLink]="sharedService.getUrl_TermsAndConditionsPage()">
    {{"TERMS OF USE"|translate}}
  </a>
  <a class="btn btn-link" [routerLink]="sharedService.getUrl_PrivacyPolicyPage()">
    {{"PRIVACY_POLICY"|translate}}
  </a>
</footer>
